<template>
  <el-dropdown placement="bottom" @command="handleCommand">
    <el-avatar icon="el-icon-user" style="cursor:pointer;height:30px;width:30px;line-height:30px"></el-avatar>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item icon="el-icon-user" :disabled="true">{{userName}}</el-dropdown-item>
      <!-- <span icon="el-icon-user">{{userName}}</span> -->
      <el-dropdown-item command="logout" icon="el-icon-setting">注销</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  data() {
    return {
      userName: ""
    };
  },
  methods: {
    //头像下拉框操作
    handleCommand(command) {
      switch (command) {
        case "logout":
          //注销
          window.sessionStorage.clear();
          this.$store.commit("saveToken", "");
          this.$Cookies.remove(_myconfig.cookies);
          let to =
            window.location.protocol + "//" + window.location.host + "/#/"; //这里重定向要加后面/#/
          let logoutUrl =
            _myconfig.loginUrl +
            "SSO/LoginOutSys?redirecturl=" +
            encodeURIComponent(to) +
            "&sysid=" +
            _myconfig.sysid;
          window.location.href = logoutUrl;
          break;

        default:
          break;
      }
    },
    getUserInfo() {
      let _this = this;
      _this.$api.get(
        "/Main/GetUserName",
        null,
        function(data) {
          if (data.code == 200) {
            _this.userName = data.msg;
          }
        },
        function(res) {},
        true
      );
    }
  },
  mounted() {
    this.getUserInfo();
  }
};
</script>
<style lang="less" scoped>
</style>